import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from 'generated/graphql';
import CheckmarkIcon from 'packages/kakapo-ui-kit/assets/icons/CheckmarkIcon';
import Color from 'packages/kakapo-ui-kit/components/common/Color';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';

const Container = styled(Box)`
	background: ${(props) => props.theme.colors.whiteBlue};
	border-radius: 4px;
`;

const ChecklistTaskCheckboxLabel = styled.label`
	width: 26px;
	height: 26px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	background: white;
	border: 1px solid ${({ theme }) => theme.colors.lightBlue};
	border-radius: 4px;
	transition: 100ms border ease-in, 100ms background-color ease-in;

	input:checked + & {
		border: 1px solid ${({ theme }) => theme.colors.primary};
		background-color: ${({ theme }) => theme.colors.primary};
	}
`;

function Checkbox(props: { name: string; checked: boolean; onChange: () => void }) {
	return (
		<Box flexShrink={0}>
			<input
				type="checkbox"
				id={`${props.name}.enabled`}
				checked={props.checked}
				onChange={props.onChange}
				style={{ display: 'none' }}
			/>
			<ChecklistTaskCheckboxLabel htmlFor={`${props.name}.enabled`}>
				<CheckmarkIcon />
			</ChecklistTaskCheckboxLabel>
		</Box>
	);
}

export default function FeedbackComposerCompetencyCard(props: {
	competency: graphql.Competency;
	selected: boolean;
	onChange: (selected: boolean, text?: string) => void;
}) {
	const { localize } = useLocalize();

	return (
		<>
			<Container p={3} mt={2}>
				<Flex alignItems="center">
					{'id' in props.competency && (
						<Box flexGrow={0} flexShrink={0} mr={3}>
							<Checkbox
								name={`competencies.${props.competency.id}`}
								checked={props.selected}
								onChange={() => props.onChange(props.selected)}
							/>
						</Box>
					)}
					<Box flexGrow={1} flexShrink={1}>
						<Box>
							<Color color="slateBlue">{localize(props.competency.title!).text}</Color>
						</Box>
					</Box>
				</Flex>
			</Container>
		</>
	);
}
